import Axios from 'axios';
import Qs from 'qs';

export default {

  // 缴费记录分页列表
  listPage(
    community_id,
    car_no,
    pay_status,
    start_time,
    end_time,
    page,
    per_page
  ) {
    return Axios.get('/ltjf/orders', {
      params: {
        community_id,
        car_no,
        pay_status,
        start_time,
        end_time,
        page,
        per_page
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    })
  },

  // 缴费记录详情
  info(
    id
  ) {
    return Axios.get(`/community/carport/parking/${id}`);
  },

  // 导出
  exportList(
    community_id,
    car_no,
    pay_status,
    start_time,
    end_time
  ) {
    return Axios.get('/ltjf/orders_export', {
      params: {
        community_id,
        car_no,
        pay_status,
        start_time,
        end_time
      },
      responseType: 'blob'
    })
  }

}